module.exports = __webpack_public_path__ + "img/logo2.b023b15f.png";